import React, { Component } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import bindModel from '../../../common/bindModel.js';


const $ = window.$;

export default class ModalHistoryScore extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoaded: false, 
            receiverFacebookId: "",
            cursor: null,
            scoreLogs: [],
            fromDate: null,
            toDate: null,
            statusButtonLoadPage: false,
            loading: false
        }

        this.getFirstHistory = this.getFirstHistory.bind(this);
        this.loadMoreHistory = this.loadMoreHistory.bind(this);
        this.reset = this.reset.bind(this);
        this.setSentinel = this.setSentinel.bind(this);

    }

    componentWillUnmount() {
        if (this.observer) {
            this.observer.disconnect();
            this.observer = null;
        }
    }

    // Callback ref cho phần tử "mốc" đặt cuối bảng:
    // khi phần tử này lọt vào viewport thì tự động load thêm (giống tab Payment).
    setSentinel(node) {
        if (this.observer) {
            this.observer.disconnect();
            this.observer = null;
        }
        this.sentinelNode = node;

        if (!node || typeof IntersectionObserver === "undefined") return;

        this.observer = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) {
                this.loadMoreHistory();
            }
        }, { rootMargin: "200px" });
        this.observer.observe(node);
    }

    // Sau khi load xong, nếu mốc vẫn nằm trong viewport (dữ liệu mới quá ngắn)
    // thì observe lại để trigger tiếp — IntersectionObserver chỉ bắn khi trạng thái đổi.
    rearmObserver() {
        if (this.observer && this.sentinelNode) {
            this.observer.unobserve(this.sentinelNode);
            this.observer.observe(this.sentinelNode);
        }
    }

    loadMoreHistory() {
        const { loading, statusButtonLoadPage } = this.state;
        if (!loading && statusButtonLoadPage) {
            this.setState({
                loading: true,
                statusButtonLoadPage:false
            });

            let fromDate = null;
            let toDate = null;
            try {
                fromDate = Date.parse(this.state.fromDate);
            } catch (error) {
                fromDate = null;
            }

            try {
                toDate = Date.parse(this.state.toDate);
            } catch (error) {
                toDate = null;
            }

            let json = {
                id: this.state.receiverFacebookId,
                cursor: this.state.cursor
            };

            axios.post(global.config.apiDomain + '/mc-user/web/admin/score-log', JSON.stringify(json), {
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(res => {
                const page = res.data.data || { logScores: [], cursor: "END" };
                let status = true;

                if (page.logScores.length < 20) {
                    status = false;
                }

                this.setState({
                    scoreLogs: this.state.scoreLogs.concat(page.logScores),
                    cursor: page.cursor,
                    statusButtonLoadPage: status,
                    loading: false
                }, () => this.rearmObserver());
            })
        }
    }

    getFirstHistory(account) {
        if (account != null) {
            let json = {
                id: this.state.receiverFacebookId,
                cursor: null
            };
            axios.post(global.config.apiDomain + '/mc-user/web/admin/score-log', JSON.stringify(json), {
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(res => {
                const page = res.data.data || { logScores: [], cursor: "END" };
                let status = true;
                if (page.logScores.length < 20) {
                    status = false;
                }
                this.setState({
                    isLoaded: true,
                    scoreLogs: page.logScores,
                    cursor: page.cursor,
                    statusButtonLoadPage: status,
                    loading: false
                });
            })
        }
    }

    componentDidUpdate() {
        const { account } = this.props;
        // Điều kiện này đúng cả khi load lần đầu ("" !== id) lẫn khi đổi user
        // (idCũ !== idMới); sau khi set xong thì bằng nhau nên không refetch lặp.
        if (account != null && this.state.receiverFacebookId !== account.id) {
            this.setState({
                isLoaded: true,
                receiverFacebookId: account.id,
                scoreLogs: [],
                cursor: null,
                fromDate: null,
                toDate: null,
                statusButtonLoadPage: false,
            }, () => this.getFirstHistory(account));
        }
    }

    reset() {
        this.setState({
            fromDate: "",
            toDate: "",
            cursor: null
        });
    }


    render() {
        const model = bindModel(this);
        const { scoreLogs, statusButtonLoadPage, loading } = this.state;

        return (
            <div>

                <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th className="align-middle text-center" scope="col" rowspan="2">Ngày nhận</th>
                            <th className="text-center" scope="col" colspan="3">Người tặng</th>
                            <th className="text-center" scope="col" colspan="3">Gia tộc</th>
                            <th className="text-center" scope="col" colspan="5">Quà</th>
                            <th className="text-center" scope="col" rowspan="2">Chi tiết</th>
                            <th className="align-middle text-center" scope="col" colspan="2">Điểm kinh nghiệm</th>
                        </tr>
                        <tr>
                            <th className="text-center" scope="col">UID</th>
                            <th className="text-center" scope="col">Tên</th>
                            <th className="text-center" scope="col">Avatar</th>
                            <th className="text-center" scope="col">UID</th>
                            <th className="text-center" scope="col">Tên</th>
                            <th className="text-center" scope="col">Thumbnail</th>
                            <th className="text-center" scope="col">ID</th>
                            <th className="text-center" scope="col">Tên</th>
                            <th className="text-center" scope="col">Ảnh</th>
                            <th className="text-center" scope="col">Giá mua</th>
                            <th className="text-center" scope="col">Giá bán</th>
                            <th className="text-center" scope="col">Điểm trước đó</th>
                            <th className="text-center" scope="col">Điểm hiện tại</th>
                        </tr>
                    </thead>
                    <tbody>
                        {scoreLogs ? (
                            scoreLogs.map((record, index) => {
                                return (
                                    <tr key={index}>
                                        <td>{new Date(record.addTime).toLocaleString()}</td>
                                        <td>{record.fromUserUid}</td>
                                        <td>{record.fromUserName}</td>
                                        <td><img src={record.fromUserAvatar} alt="" style={{width: "100px"}} /></td>
                                        <td>{record.fromFamilyUid}</td>
                                        <td>{record.fromFamilyName}</td>
                                        <td>{record.fromFamilyAvatar}</td>
                                        <td>{record.giftId}</td>
                                        <td>{record.giftName}</td>
                                        <td><img src={record.giftImage} alt="" style={{width: "100px"}} /></td>
                                        <td>{record.buyPrice}</td>
                                        <td>{record.sellPrice}</td>
                                        <td>{record.atClassAndPosition}</td>
                                        <td>{record.oldScore}</td>
                                        <td>{record.newScore}</td>
                                    </tr>
                                )
                            })
                        ) : <></>}

                    </tbody>
                </table>

                {/* Mốc infinite scroll: scroll tới đây là tự load trang sau */}
                {scoreLogs && scoreLogs.length > 0 && (
                    <div ref={this.setSentinel} className="text-center mb-lg-4"
                         style={{ minHeight: "40px", padding: "10px 0" }}>
                        {loading ?
                            <span><i className="fa fa-spinner fa-spin"></i> Đang tải thêm...</span> :
                            (statusButtonLoadPage ?
                                <button onClick={this.loadMoreHistory} className="btn-red">Xem thêm</button> :
                                <span style={{ color: "#999" }}>Đã hiển thị hết</span>)}
                    </div>
                )}
            </div>
        )
    }
}